/**
 * Role display badge component
 * Shows the current role of the user
 */
const RoleDisplay = ({ role, isWinner = false }) => {
  const roleColor =
    role === 'validator'
      ? 'from-yellow-500 to-orange-500'
      : 'from-blue-500 to-cyan-500';

  const roleIcon =
    role === 'validator' ? (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M19 12h-2v-2h-2v2h-2v2h2v2h2v-2h2zm-8-6H9v2H7V6zm0 6H9v2H7v-2zm0 6H9v2H7v-2z" />
      </svg>
    ) : (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
      </svg>
    );

  return (
    <div
      className={`bg-gradient-to-r ${roleColor} rounded-xl p-4 border border-white/20 `}
    >
      <div className="flex items-center gap-3">
        <div className="text-white">{roleIcon}</div>
        <div>
          <p className="text-white/80 text-sm font-medium">Your Role</p>
          <p className="text-white font-semibold text-lg capitalize">{role}</p>
          {isWinner && (
            <p className="text-white text-xs mt-1 font-semibold bg-red-500 px-2 py-1 rounded">
              🏆 Staking Winner
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default RoleDisplay;
